<template>
  <div class="col-lg-6 col-md-12 col-xs-12">
    <div class="textcard">
      <h2>Why & when should<br>you choose residential proxies?</h2>
      <br>
      <p>
        We want you to make the perfect proxy choice, so we have listed a few scenarios when
        ProxyScrape residential proxies could be the ideal fit for you:
      </p>
      <ul>
        <li>Your target website blocks you very quickly</li>
        <li>You don't consume a lot of traffic or are not budget restrained</li>
        <li>You need many proxies to stay unblocked from your target</li>
        <li>Your target has strict security rules</li>
        <li>You don't need a proxy list, and back-connect proxies will suit you</li>
      </ul>
      <p>
        There are a lot more scenarios when residential proxies might be a perfect choice for you.
        Do you want to test the proxies? We offer a refund when less than 1GB of traffic is
        used within 3 days when paid with PayPal or credit card.<br /><br />
        Does this sound like something you need? Take a look at our pricing.
      </p>
      <a
        href="#pricing"
        style="font-weight: 600;
        text-decoration: none;">
        See pricing
        <img
          alt=""
          src='@/assets/img/svg/right-arrow.svg'
          style="height: 14px;" />
      </a>
    </div>
  </div>

  <div class="col-lg-6 col-md-12 col-xs-12">
    <div class="imagecard">
      <img src="https://cdn.proxyscrape.com/img/when_premium.png" alt="when choose premium">
    </div>
  </div>
</template>

<script lang='ts' setup>

</script>

<style scoped>

</style>
